import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { ArcRoutes } from '../../constants/routes';
import { CompensationHistory } from './compensation-history/compensation-history';
import { IndividualCompensation } from './individual-compensation/individual-compensation';
import { useEmploymentInfo } from '../employment/useEmployment';
import { useCompensationInfo } from './compensation-history/useCompensation';
import { EmploymentState } from '../employment/employment-model';
import { ScheduledPayment } from './scheduled-payment/scheduled-payment';
import { OneTimePayment } from './one-time-payment/one-time-payment';
import { ScheduledHoursHistory } from './scheduled-hours/scheduled-hours-history';
import { ScheduledHoursApp } from './scheduled-hours/scheduled-hours';
import { TcsmEpiApiState, TcsmStates } from '../../../../root/tcsm-model';
import { useBasePath } from '../../../../global/hooks/useBasePath';

export function Compensation() {
    const routeMatch = useRouteMatch();
    const location = useLocation();
    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const employmentInfoLoaded = useEmploymentInfo();

    const compensationInfoLoaded =
        useCompensationInfo(employmentState?.currentEmployee
            ? [employmentState?.currentEmployee?.employment_id]
            : [],
            employmentState?.currentEmployee?.id);


    if (!employmentState?.currentEmployee) {

        const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);
        return (
            <Redirect to=
                {
                    {
                        pathname: employeeSelect,
                        state: {
                            actionLink: location.pathname,
                        },
                    }
                }
            />);

    }

    if (!employmentInfoLoaded || !compensationInfoLoaded) {
        return (<p>loading...</p>);
    }

    if (employmentInfoLoaded && isEmpty(employmentState.currentEmployment)) {
        return (<div dangerouslySetInnerHTML={{ __html: epiProps?.compensationSettingsState?.epiContent?.noCurrentCompensationMessage }} />);
    }

    return (
        <>
            <Switch>
                <Route exact path={routeMatch.path} component={IndividualCompensation} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.History}`} component={CompensationHistory} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.ScheduledPayment}/:scheduledPaymentNumber?`} component={ScheduledPayment} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.OneTimePayment}/:oneTimePaymentNumber?`} component={OneTimePayment} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.ScheduledHoursHistory}`} component={ScheduledHoursHistory} />
                <Route exact path={`${routeMatch.path}${ArcRoutes.ScheduledHours}/:scheduledHoursId?`} component={ScheduledHoursApp} />
            </Switch>
        </>
    );
}